import React from "react";
import configData from '../../config/config.json';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import './index.css';
import { addLangParam } from '../../utils/apiHelpers';

const API_ENDPOINT = configData.API_ENDPOINT;

class Heading extends React.Component {

    constructor (props) {
        super(props)
        //console.log(props)

        this.state = {
            'popup' : this.props?.show_popup,
        }
       
        const QS = queryString.parse(window.location.search);
        //console.log(QS)

        this.city_id = QS?.destination;
        if (this.city_id>0) {
            try {
                const base = window.location.pathname.split('/');
                this.city_name = decodeURIComponent(base[1]);
            } catch (e) {
                this.city_name = '';
            }
            
        } else
            this.city_id = null;

        // binding
        this.handleToggleDestiantionTab = this.handleToggleDestiantionTab.bind(this)
        this.handleSelectDestination = this.handleSelectDestination.bind(this); 

    }

    componentDidMount() {
        if (this.props.destination_id)
            this.fetchDestination(this.props.destination_id)
    }
    

    

    async fetchDestination(city_id) {

        const baseUrl = `${API_ENDPOINT}/search/destinations/${city_id}/`;
        const url = addLangParam(baseUrl);

        return (
          await fetch(url)
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              throw new Error(this.props.t('common.errors.network.error303'));
            }
          })
          .then(response => {
            // Find city in cities array
            const currentCity = response.find(item=>item.city_id==city_id)
            

            // send destination details to caller
            if (this.props?.sendDataToCaller) {
                // if we're in a page of specific city, send only city details
                // otherwise, send all cities
                if  (city_id) {
                    this.props.sendDataToCaller(currentCity);
                } else {
                    this.props.sendDataToCaller(response);
                }
            }
                
        
            this.setState((prevState)=>({
                ...prevState,
                'destination': currentCity,
                'destinations': response
            }))
          })
          .catch(error=>this.setState(
              {
                error, 
                  'isLoading': false,
                  filters: {...this.state.filters }
              }
          ))
        )
    }

    async fetchDestinations(city_id) {

        const baseUrl = `${API_ENDPOINT}/search/destinations/`;
        const url = addLangParam(baseUrl);

        return (
          await fetch(url)
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              throw new Error(this.props.t('common.errors.network.error303'));
            }
          })
          .then(response => {
            // Find city in cities array
            const currentCity = response.find(item=>item.city_id==city_id)
            

            // send destination details to caller
            if (this.props?.sendDataToCaller) {
                // if we're in a page of specific city, send only city details
                // otherwise, send all cities
                if  (city_id) {
                    this.props.sendDataToCaller(currentCity);
                } else {
                    this.props.sendDataToCaller(response);
                }
            }
                
        
            this.setState((prevState)=>({
                ...prevState,
                'destination': currentCity,
                'destinations': response
            }))
          })
          .catch(error=>this.setState(
              {
                error, 
                  'isLoading': false,
                  filters: {...this.state.filters }
              }
          ))
        )
    }

  
      
    handleToggleDestiantionTab = (event) => {
        if (!this.state?.destinations || this.state?.destinations?.length<=1) 
            this.fetchDestinations(this.props.destination_id);

        const currentState = this.state;
        currentState.popup = true;
        this.setState(currentState);

        window.dataLayer = window.dataLayer || [];
        const event_name = 'DestinationChangeClicked';
        console.log('GTM event: ' + event_name)
        window.dataLayer.push({
            event: event_name,
            'pageUrl': window.location,
            'pageTitle' : window.title,
        });
        // refresh data
        //this.getFiltersUpdate(this.state.filters)
    }

    
    /** 
     * Update destination state based on selection
     */
    handleSelectDestination = (event, cityId, cityName) => {

        event.stopPropagation()
        
        /*if (cityId!='all')
            window.location = `/${cityName}/?destination=${cityId}`
        else {
            this.handleClose(event)
            window.location = `#deals`
        }*/

        //remove QS property from parent filters
        this.props.filters.QS = undefined;

        // convert filters of parent page to querystring
        const filtersQuerystring = this.objectToQueryString(this.props.filters)

        // if user selected a specific city
        if (cityId!=='all') {
            // This will redirect user to destination page and will keep all existing filters => we removed this because if we were is last minute filter it would user to the destination and show only last minute deals! we prefer to show all months in the destination instead
            //window.location = `/${cityName}/?destination=${cityId}&`  + filtersQuerystring
            window.location = `/${cityName}/?destinations=${cityId}`
        }
        else {
            // if user wants to see results for all cities
            window.location = '/best-deals/?' + filtersQuerystring
        }
        
    }

    /**
     * Convert filters object to querysting
     * 
     * @param {} obj 
     * @returns 
     */
    objectToQueryString(obj) {
        console.log(obj)
        if (!obj)   
            return 
        var str = [];
        for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            if (obj[p])
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
        return str.join("&");
    }

    /**
     * Close window
     * 
     * @param {*} event 
     */
    handleClose = (event) => {
        this.setState({
            popup: false
        });
//        this.state.popup = false;
    }


    render() {
        return (
            <>
                <Dialog open={this.state?.popup===true} onClose={e=>{this.handleClose(e)}}>
                    <DialogTitle id="alert-dialog-title">{this.props.t('heading.destSelectionTitle')}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <div className="destinations_popup noselect">
                            
                            <div className='window'>
                                <div className='content'>
                                    <div className='list'>
                                        <div onClick={e=>this.handleSelectDestination(e, 'all', this.props.t('heading.allDestinations'))} className={!this.state?.destination || this.state?.destination===''|| this.state?.destination==='all'?' item selected':'item'}>
                                            <div className="icon"><FontAwesomeIcon icon={faPlaneDeparture}   style={{transform:'scaleX(-1)'}} /></div>
                                            <div className="text">{this.props.t('heading.noPreference')}</div>
                                        </div>
                                        {

                                            this.state?.destinations?.sort().map(dest=>
                                                // Here goes your models option
                                                (<div key={dest?.city_id} onClick={e=>this.handleSelectDestination(e, dest.city_id, dest.city_name)} className={this.props.destination*1===dest?.city_id*1?'item selected':'item'}>
                                                    <div className="icon"><FontAwesomeIcon icon={faPlaneDeparture}   style={{transform:'scaleX(-1)'}} /></div>
                                                    <div className="text">{dest.city_name}</div>
                                                </div>)
                                            )
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        </DialogContentText>
                    </DialogContent>
                    
                </Dialog>


                <div className="change_destination_heading_wrapper">
                    <div className="change_destination_heading" style={this.props?.source=='homepage'?{padding:0}:{}}>
                        <h2 className={this.props?.source}>{this.props?.text} {this.city_id&&!this.state.destination?this.city_name:(this.state?.destination?(this.props.t('heading.to', { city: this.state?.destination?.city_name })):'')} {this.props?.month_name?this.props.t('heading.inMonth', { month: this.props?.month_name }):``}</h2>
                        {this.props?.overview?(<h3 className='overview'>{this.props?.overview}</h3>):''}
                        {this.props?.subheader?(<h3 className='subheader' style={{color:'#555', fontWeight:800, fontSize:'1.15em', margin:0}}>{this.props?.subheader}</h3>):''}
                    </div>
                </div>
            </>
        )    
    }

}
export default withTranslation()(Heading)